import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import styles from "./faqs.module.css";

const faqs = [
  {
    question: "What types of camping experiences do you offer?",
    answer:
      "We offer lakeside tents, forest cabins, glamping setups, and adventure camping trips suitable for families, friends, and solo travelers.",
  },
  {
    question: "How can I book a campsite?",
    answer:
      "You can book your campsite online through our website, call us directly, or visit our reception to reserve your spot.",
  },
  {
    question: "Do you provide equipment for camping?",
    answer:
      "Yes, we provide tents, sleeping bags, cooking gear, and other essential camping equipment for a comfortable and safe stay.",
  },
  {
    question: "Are there activities for kids and families?",
    answer:
      "Absolutely! We have nature trails, bonfires, adventure games, fishing, and guided tours suitable for all ages.",
  },
  {
    question: "Is it possible to organize group events or retreats?",
    answer:
      "Yes, we welcome group bookings, corporate retreats, and special events with customized packages to make your stay memorable.",
  },
];

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>

        {/* Background watermark Q mark */}
        <span className={styles.watermark} aria-hidden="true">?</span>

        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>Frequently Asked Questions</h2>
          <p className={styles.description}>
            Everything you need to know about booking, facilities, and your stay at Dima Niwas Campsite.
          </p>
        </div>

        {/* FAQ list */}
        <div className={styles.faqList}>
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className={`${styles.faqItem} ${isOpen ? styles.faqItemOpen : ""}`}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className={styles.faqButton}
                  aria-expanded={isOpen}
                >
                  <div className={styles.questionRow}>
                    <span className={styles.badge}>0{index + 1}</span>
                    <span className={styles.question}>{faq.question}</span>
                  </div>
                  <ChevronDown
                    className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""}`}
                    size={20}
                  />
                </button>

                <div className={`${styles.answerWrapper} ${isOpen ? styles.answerOpen : ""}`}>
                  <p className={styles.answer}>{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQs;


